// extracted by mini-css-extract-plugin
module.exports = {"longHistory":"styles_long-history__FU_MO","heading":"styles_heading__JKFeI","tabsList":"styles_tabs-list__aKmha","activeTab":"styles_active-tab__DLSFK","tab":"styles_tab__guZNs"};